import React from 'react';
import { Box, TextField } from '@mui/material';
import AdminFormRow from '../../../../components/admin/AdminFormRow';
import AdminSectionHeading from '../../../../components/admin/AdminSectionHeading';
import type { GameFormData, GameFormErrors } from '../../../../types/features/games';
import { adminFormFieldSx } from '../../../../styles/adminComponentStyles';

interface GameDialogScheduleFieldsProps {
  errors: GameFormErrors;
  formData: GameFormData;
  loading: boolean;
  onInputChange: (field: keyof GameFormData, value: string) => void;
}

const GameDialogScheduleFields: React.FC<GameDialogScheduleFieldsProps> = ({
  errors,
  formData,
  loading,
  onInputChange,
}) => (
  <>
    <AdminSectionHeading>Schedule</AdminSectionHeading>
    <AdminFormRow label="Dates">
      <Box sx={{ display: 'grid', gap: 1, gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' } }}>
        <TextField
          fullWidth
          size="small"
          label="Start Date"
          type="date"
          value={formData.start_date}
          onChange={(event) => onInputChange('start_date', event.target.value)}
          error={!!errors.start_date}
          helperText={errors.start_date}
          disabled={loading}
          InputLabelProps={{ shrink: true }}
          sx={adminFormFieldSx}
          inputProps={{ 'aria-label': 'Start Date' }}
        />
        <TextField
          fullWidth
          size="small"
          label="End Date"
          type="date"
          value={formData.end_date}
          onChange={(event) => onInputChange('end_date', event.target.value)}
          error={!!errors.end_date}
          helperText={errors.end_date}
          disabled={loading}
          InputLabelProps={{ shrink: true }}
          sx={adminFormFieldSx}
          inputProps={{ 'aria-label': 'End Date' }}
        />
      </Box>
    </AdminFormRow>
  </>
);

export default React.memo(GameDialogScheduleFields);
